import React from "react";
import { Avatar, HStack, Text } from "@chakra-ui/react";
import SchemaBadge from "./SchemaBadge";

// A person on a task or order, easy to spot: an initials avatar, the name in
// bold body-size text and the schema they're working in. `person` is the
// backend's { name, email, current_schema }; name / email / schema cover
// callers that only have flat fields.
export default function PersonChip({ person, name, email, schema, label, size = "sm", avatarSize = "xs", ...rest }) {
  const shown = person?.name || person?.email || name || email || "Someone";
  const currentSchema = person?.current_schema ?? schema;
  return (
    <HStack as="span" display="inline-flex" spacing={1.5} align="center" verticalAlign="middle"
            data-testid="person-chip" {...rest}>
      {label && <Text as="span" fontSize="xs" color="gray.500">{label}</Text>}
      <Avatar size={avatarSize} name={shown === "Someone" ? undefined : shown} />
      <Text as="span" fontSize={size} fontWeight="semibold" color="gray.800" _dark={{ color: "gray.100" }}>
        {shown}
      </Text>
      <SchemaBadge schema={currentSchema} />
    </HStack>
  );
}
